import { BaseService } from "./BaseService";

export const DotacaoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos dotações:', error);
            return false;
        }
    },
    async select() {
        try {
            return await BaseService.fetchResponseFromAPIGet('dotacao/select');
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas dotacões:', error);
            return false;
        }
    },
    async selectWithUnidade(unidade) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`dotacao/select/${unidade}`);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas dotacões:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`dotacao/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de dotações:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir dotações:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar dotações:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar dotações:', error);
            return false;
        }
    }, 
    async getUnidadesPrimarias(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/get-unidades-primarias', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas unidades primárias:', error);
            return false;
        }
    },
    async getEstatisticas(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/get-estatisticas', postData);
        } catch (error) {
            console.error('Ocorreu ao buscar estatisticas:', error);
            return false;
        }
    },
    async alocarValores(postData) { 
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/alocar-valores', postData);
        } catch (error) {
            console.error('Ocorreu ao alocar valores:', error);
            return false;
        }
    }, 
    async removerValores(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/remover-valores', postData);
        } catch (error) {
            console.error('Ocorreu ao remover valores:', error);
            return false;
        }
    },
    async getAlocacoesConsolidadas(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/get-alocacoes-consolidadas', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao listar alocações consolidadas:', error);
            return false;
        }
    },
    async getEstatisticasConsolidadas(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/get-estatisticas-consolidadas', postData);
        } catch (error) {
            console.error('Ocorreu ao buscar estatísticas consolidadas:', error);
            return false;
        }
    },
    async alocarValoresConsolidados(postData) { 
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/alocar-valores-consolidados', postData);
        } catch (error) {
            console.error('Ocorreu ao alocar valores consolidados:', error);
            return false;
        }
    }, 
    async removerAlocacaoConsolidada(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('dotacao/remover-alocacao-consolidada', postData);
        } catch (error) {
            console.error('Ocorreu ao remover alocação consolidada:', error);
            return false;
        }
    },
    async getHistoricoMovimentacoes(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`dotacao/${id}/historico-movimentacoes`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar histórico de movimentações:', error);
            return false;
        }
    }
}